import axios from 'axios';
import getBaseUrl from '../../../shared/utils/Host';

const BaseUrl = getBaseUrl();
const API_URL_WEB = `${BaseUrl}promo`;

// const token = localStorage.getItem('token');

export const getPromoProductAll = () => {
    const token = localStorage.getItem('token');

    return axios.get(`${API_URL_WEB}`, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}

export const getPromoProduct = () => {
    const token = localStorage.getItem('token');
    // find-all-active
    // return axios.get(`${API_URL_WEB}/find-all-product`, {
    return axios.get(`${API_URL_WEB}/find-all-active`, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}

export const getPromoProductById = (id) => {
    const token = localStorage.getItem('token');

    return axios.get(`${API_URL_WEB}/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}

export const createPromoProduct = (promoProduct) => {
    const token = localStorage.getItem('token');

    return axios.post(`${API_URL_WEB}`,
        promoProduct, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}
export const updatePromoProduct = (id, promoProduct) => {
    const token = localStorage.getItem('token');

    return axios.patch(API_URL_WEB + `/${id}`,
        promoProduct, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}

export const deletePromoProduct = (id) => {
    const token = localStorage.getItem('token');

    return axios.delete(`${API_URL_WEB}/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}

export const updateActive = (id, promoProduct) => {
    const token = localStorage.getItem('token');

    return axios.patch(API_URL_WEB + `/active-promo/${id}`,
        promoProduct, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}
